"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = exports.deserializeUnchecked = exports.deserialize = exports.struct = exports.map = exports.Data = void 0;
const web3_js_1 = require("@solana/web3.js");
const borsh_1 = require("borsh");
Object.defineProperty(exports, "deserialize", { enumerable: true, get: function () { return borsh_1.deserialize; } });
Object.defineProperty(exports, "deserializeUnchecked", { enumerable: true, get: function () { return borsh_1.deserializeUnchecked; } });
Object.defineProperty(exports, "serialize", { enumerable: true, get: function () { return borsh_1.serialize; } });
const extendBorsh = () => {
    ;
    borsh_1.BinaryReader.prototype.readPublicKey = function () {
        const reader = this;
        const array = reader.readFixedArray(32);
        return new web3_js_1.PublicKey(array);
    };
    borsh_1.BinaryWriter.prototype.writePublicKey = function (value) {
        const writer = this;
        writer.writeFixedArray(value.toBuffer());
    };
};
extendBorsh();
class Data {
    constructor(args = {}) {
        Object.assign(this, args);
    }
    static struct(fields) {
        return (0, exports.struct)(this, fields);
    }
    static map(types, fields) {
        return (0, exports.map)(types, fields);
    }
    static serialize(args = {}) {
        return Buffer.from((0, borsh_1.serialize)(this.SCHEMA, new this(args)));
    }
    static deserialize(data) {
        return (0, borsh_1.deserializeUnchecked)(this.SCHEMA, this, data);
    }
}
exports.Data = Data;
const map = (type, fields) => {
    const entries = type.map((v, i) => {
        return [v, { kind: 'struct', fields: fields[i] }];
    });
    return new Map(entries);
};
exports.map = map;
const struct = (type, fields) => {
    return new Map([[type, { kind: 'struct', fields }]]);
};
exports.struct = struct;
//# sourceMappingURL=borsh.js.map